import React, { useState, useEffect } from "react";
import { formatCurrency } from "../utils/helpers";

function AnimatedNumber({ value }) {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    let start = 0;
    const end = value;
    const duration = 1000;
    const step = end / (duration / 16);
    const timer = setInterval(() => {
      start += step;
      if (start >= end) { setDisplay(end); clearInterval(timer); }
      else setDisplay(start);
    }, 16);
    return () => clearInterval(timer);
  }, [value]);
  return <>{formatCurrency(display)}</>;
}

export default function SummaryCards({ income, expense, balance, theme }) {
  const dark = theme === "dark";
  const [visible, setVisible] = useState(false);
  useEffect(() => { setTimeout(() => setVisible(true), 100); }, []);

  const cards = [
    {
      title: "Total Balance",
      value: balance,
      icon: "◎",
      gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
      glow: "rgba(99,102,241,0.3)",
      change: balance >= 0 ? "+Surplus" : "−Deficit",
      changeColor: balance >= 0 ? "#6ee7b7" : "#f87171",
    },
    {
      title: "Total Income",
      value: income,
      icon: "↑",
      gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
      glow: "rgba(16,185,129,0.3)",
      change: "All time",
      changeColor: "#6ee7b7",
    },
    {
      title: "Total Expenses",
      value: expense,
      icon: "↓",
      gradient: "linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)",
      glow: "rgba(244,63,94,0.3)",
      change: `${((expense / income) * 100).toFixed(0)}% of income`,
      changeColor: "#fca5a5",
    },
  ];

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 20 }}>
      {cards.map((card, i) => (
        <div key={card.title} style={{
          background: dark ? "rgba(255,255,255,0.04)" : "#ffffff",
          border: `1px solid ${dark ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.08)"}`,
          borderRadius: 16, padding: "20px 24px", position: "relative", overflow: "hidden",
          transform: visible ? "translateY(0)" : "translateY(20px)",
          opacity: visible ? 1 : 0,
          transition: `all 0.5s cubic-bezier(0.34, 1.2, 0.64, 1) ${i * 0.1}s`,
          cursor: "default",
          boxShadow: dark ? `0 4px 24px rgba(0,0,0,0.3)` : "0 4px 20px rgba(0,0,0,0.06)",
        }}
          onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-4px)"; e.currentTarget.style.boxShadow = `0 12px 40px ${card.glow}`; }}
          onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = dark ? "0 4px 24px rgba(0,0,0,0.3)" : "0 4px 20px rgba(0,0,0,0.06)"; }}
        >
          {/* Background accent */}
          <div style={{
            position: "absolute", top: -20, right: -20, width: 100, height: 100,
            borderRadius: "50%", background: card.glow, filter: "blur(30px)",
          }} />

          <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", position: "relative" }}>
            <div style={{ flex: 1 }}>
              <p style={{ margin: "0 0 8px", color: dark ? "#64748b" : "#94a3b8", fontSize: 13, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>
                {card.title}
              </p>
              <p style={{ margin: "0 0 12px", color: dark ? "#f1f5f9" : "#0f172a", fontSize: 26, fontWeight: 700, letterSpacing: "-0.03em" }}>
                <AnimatedNumber value={card.value} />
              </p>
              <span style={{ fontSize: 12, color: card.changeColor, fontWeight: 500 }}>{card.change}</span>
            </div>
            <div style={{
              width: 44, height: 44, borderRadius: 12, background: card.gradient,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 20, color: "#fff", flexShrink: 0, marginLeft: 12,
              boxShadow: `0 4px 14px ${card.glow}`,
            }}>
              {card.icon}
            </div>
          </div>

          {/* Bottom progress bar */}
          <div style={{ marginTop: 16, height: 3, background: dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.06)", borderRadius: 2 }}>
            <div style={{
              height: "100%", borderRadius: 2, background: card.gradient,
              width: card.title === "Total Expenses" ? `${Math.min((expense / income) * 100, 100)}%` : "100%",
              transition: "width 1s ease 0.5s",
            }} />
          </div>
        </div>
      ))}
    </div>
  );
}
